module.exports = __webpack_public_path__ + "static/media/ae-social-logo.dd8702d4.png";